export default __webpack_public_path__ + "static/wc-product-detailed-batch-code-image-7837d709f74e2ddee57c43b748c24244.webp";